import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-603c1282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "license-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "license-container-body" }
const _hoisted_5 = { class: "lm-row" }
const _hoisted_6 = { class: "lm-column" }
const _hoisted_7 = { class: "license-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Product", -1))
const _hoisted_9 = { class: "lm-column" }
const _hoisted_10 = { class: "license-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Type", -1))
const _hoisted_12 = { class: "lm-row" }
const _hoisted_13 = { class: "lm-column" }
const _hoisted_14 = { class: "license-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Maximum Activations", -1))
const _hoisted_16 = { class: "lm-column" }
const _hoisted_17 = { class: "license-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Domain", -1))
const _hoisted_19 = { class: "lm-row" }
const _hoisted_20 = { class: "lm-column" }
const _hoisted_21 = { class: "license-info" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Expired Days", -1))
const _hoisted_23 = { class: "lm-column" }
const _hoisted_24 = { class: "license-info" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Expired Date", -1))
const _hoisted_26 = {
  key: 0,
  class: "lm-row"
}
const _hoisted_27 = { class: "lm-column" }
const _hoisted_28 = { class: "account-info" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Stripe Subscription ID", -1))
const _hoisted_30 = { class: "lm-column" }
const _hoisted_31 = { class: "account-info" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Stripe Subscription Status", -1))
const _hoisted_33 = { class: "lm-column" }
const _hoisted_34 = { class: "account-info" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Stripe Cancelled At", -1))
const _hoisted_36 = { class: "update-actions" }
const _hoisted_37 = {
  align: "right",
  style: {"font-size":"small","font-style":"italic","color":"grey"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = {
  key: 0,
  align: "right",
  style: {"font-size":"small","font-style":"italic","color":"grey"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.modalHeader), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Dropdown, {
              class: "form-control",
              disabled: !!_ctx.license.id,
              optionLabel: "name",
              optionValue: "name",
              modelValue: _ctx.license.product,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.license.product) = $event)),
              options: _ctx.availableProducts
            }, null, 8, ["disabled", "modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Dropdown, {
              class: "form-control",
              optionLabel: "name",
              optionValue: "name",
              modelValue: _ctx.license.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.license.type) = $event)),
              options: _ctx.availableLicenseTypes
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_InputText, {
              type: "number",
              placeholder: "Maximum Activations",
              min: "0",
              class: "form-control",
              modelValue: _ctx.license.maximumActivations,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.license.maximumActivations) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_InputText, {
              type: "text",
              class: "form-control",
              modelValue: _ctx.license.licenseDomain,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.license.licenseDomain) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_InputText, {
              type: "number",
              placeholder: "Expired Days",
              class: "form-control",
              modelValue: _ctx.license.expiredDays,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.license.expiredDays) = $event)),
              onChange: _ctx.processExpiredDaysChange
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Datepicker, {
              placeholder: "Expired Date",
              autoApply: "",
              modelValue: _ctx.license.expiryDate,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.license.expiryDate) = $event)),
                _ctx.updateExpiryDays
              ],
              enableTimePicker: false
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ])
      ]),
      (_ctx.license.id && !_ctx.accountStore.isCustomer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.license.stripeSubscriptionId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.license.stripeSubscriptionId) = $event)),
                  disabled: "true"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.license.stripeSubscriptionStatus,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.license.stripeSubscriptionStatus) = $event)),
                  disabled: "true"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.license.stripeCancelAt,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.license.stripeCancelAt) = $event)),
                  disabled: "true"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          label: _ctx.license.id ? 'Update' : 'Create',
          class: "p-button-secondary p-button",
          disabled: !_ctx.isFormValid,
          onClick: _ctx.submitCreateUpdateForm
        }, null, 8, ["label", "disabled", "onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.cancelCreateUpdateForm,
          label: "Cancel",
          class: "p-button-secondary p-button-outlined"
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("span", null, [
        _createTextVNode(" Created by "),
        _createElementVNode("b", null, _toDisplayString(_ctx.license.createdBy), 1),
        _createTextVNode(" on "),
        _createElementVNode("b", null, _toDisplayString(_ctx.license.createdDate), 1)
      ])
    ]),
    (_ctx.license.modifiedBy != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("span", null, [
            _createTextVNode(" Modified by "),
            _createElementVNode("b", null, _toDisplayString(_ctx.license.modifiedBy), 1),
            _createTextVNode(" on "),
            _createElementVNode("b", null, _toDisplayString(_ctx.license.modifiedDate), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}